<template lang="pug">
.he-wrap(:class="[{'he-wrap--app': $store.state.general.isApp}]" )
	transition(name="fade")
		.he(v-if="isHeadReady" ref="he")
			NoSignal
			.he-top
				.he-top-info
					.he-top-info-itm
						i: font-awesome-icon(icon="calendar-alt")
						.he-top-info-itm__date(v-if="isCurrentMatchLoaded && match_info") 
							span {{ parsedDate }}
							span {{ parsedTime }}

				.he-top__round(
					:class="$store.state.general.navigation_prematch ? 'he-top__round--back' : '' " 
					@click="$store.state.general.navigation_prematch ? goPreviousMatch() : toggleNav()" 
					role="button")
					i: font-awesome-icon(icon="chevron-left")

					span(v-if="isCurrentMatchLoaded && !$store.state.general.navigation_prematch") {{ parsedRound }}
					span(v-if="isCurrentMatchLoaded && $store.state.general.navigation_prematch") {{ $t('Back') }}

				img.he-top__comp(
					v-if="isCurrentMatchLoaded"
					:src="getCompetitionLogo"
					:alt="match_info ? match_info.competition.name : 'competiticion'"
				)

				router-link.he-top-logo(v-if="!$store.state.general.isApp" :to="{name: $store.state.general.lang+'.home'}")
					img(src="/acb-live.png", alt="acb live")

				.he-top-logo(v-if="$store.state.general.isApp")
					img(src="/acb-live.png", alt="acb live")

				.he-top-patro(v-if="match_info")
					//- Specific sponsors by competition
					a.he-top-patro__item(v-if="(match_info.id_competition != 2)" href="https://www.endesa.com/es.html" target="_blank" rel="noopener"): img(src="/endesa-logo-partner.png", alt="endesa")
					a.he-top-patro__item(v-if="(match_info.id_competition != 2)" v-show="(match_info.id_competition != 10)" href="https://www.movistar.es/" target="_blank" rel="noopener"): img(src="/movistar-logo.png", alt="movistar")
					a.he-top-patro__item(v-if="(match_info.id_competition != 2)" href="https://www.ionos.es/" target="_blank" rel="noopener"): img(src="/ionos-logo-partner.png", alt="ionos")
					a.he-top-patro__item(v-if="(match_info.id_competition != 2)" href="https://www.toyota.es/" target="_blank" rel="noopener"): img(src="/toyota-logo-partner.png", alt="toyota")
					a.he-top-patro__item(v-if="(match_info.id_competition != 2)" href="https://www.bancomediolanum.es/es-ES/" target="_blank" rel="noopener"): img(src="/mediolanum-logo.png", alt="Banco Mediolanum")

					a.he-top-patro__item(v-if="(match_info.id_competition == 2)" href="https://www.movistar.es/" target="_blank" rel="noopener"): img(src="/movistar-logo.png", alt="movistar")
					a.he-top-patro__item(v-if="(match_info.id_competition == 2)" href="https://www.endesa.com/es.html" target="_blank" rel="noopener"): img(src="/endesa-logo-partner.png", alt="endesa")
					a.he-top-patro__item(v-if="(match_info.id_competition == 2)" href="https://www.ionos.es/" target="_blank" rel="noopener"): img(src="/ionos-logo-partner.png", alt="ionos")
					a.he-top-patro__item(v-if="(match_info.id_competition == 2)" href="https://www.toyota.es/" target="_blank" rel="noopener"): img(src="/toyota-logo-partner.png", alt="toyota")
					a.he-top-patro__item(v-if="(match_info.id_competition == 2)" href="https://www.bancomediolanum.es/es-ES/" target="_blank" rel="noopener"): img(src="/mediolanum-logo.png", alt="Banco Mediolanum")

			.ge-match.ge-match--head
				MatchInfo(:match_info="match_info")
				.ge-match-fault-wrap(v-show="this.$store.state.match.status == 'playing'" v-if="!match_info.finalized && isCurrentMatchLoaded")
					.ge-match-fault.ge-match-fault--local(:class="{'ge-match-fault--empty': !localFouls}")
						.ge-match-fault__item(
							v-for="index in 5"
							:key="index"
							v-if="!isLocalBonus"
							:class="{'ge-match-fault__item--current': (localFouls == index)}"
						)
						span(v-if="isLocalBonus") {{ $t('Bonus') }}
					.ge-match-fault.ge-match-fault--visitor(:class="{'ge-match-fault--empty': !visitorFouls}")
						.ge-match-fault__item(
							v-for="index in 5"
							v-if="!isVisitorBonus"
							:class="{'ge-match-fault__item--current': visitorFouls == index}")
						span(v-if="isVisitorBonus") {{ $t('Bonus') }}

				.ge-match-period-wrap(v-if="isCurrentMatchLoaded")
					.ge-match-period(
						v-for="period of match_info.period_marker"
						:key="period.quarter"
						)
						span {{ getPeriodStr(period.quarter) }}
						.ge-match-period-score-wrap
							span.ge-match-period-score
								AnimatedValue(:value="period.local_points")
							span.ge-match-period-score
								AnimatedValue(:value="period.visitor_points")
			//- div(v-if="match_info")
			a(v-if="showBroadcast" :href="match_info ? match_info.broadcast[0].url : ''").he__btn_tv
				span {{ $t('Watch match') }}
				img(:src="match_info.broadcast[0].url_image", :alt="match_info.id_team_local")

			.he-btm-patro(v-if="match_info")
				//- Specific sponsors by competition (default)
				a.he-btm-patro__item(v-if="(match_info.id_competition != 2)" href="https://www.endesa.com/es.html" target="_blank" rel="noopener"): img(src="/endesa-logo-partner.png", alt="endesa")
				a.he-btm-patro__item(v-if="(match_info.id_competition != 2)" v-show="(match_info.id_competition != 10)" href="https://www.movistar.es/" target="_blank" rel="noopener"): img(src="/movistar-logo.png", alt="movistar")
				a.he-btm-patro__item(v-if="(match_info.id_competition != 2)" href="https://www.ionos.es/" target="_blank" rel="noopener"): img(src="/ionos-logo-partner.png", alt="ionos")
				a.he-btm-patro__item(v-if="(match_info.id_competition != 2)" href="https://www.toyota.es/" target="_blank" rel="noopener"): img(src="/toyota-logo-partner.png", alt="toyota")
				a.he-btm-patro__item(v-if="(match_info.id_competition != 2)" href="https://www.bancomediolanum.es/es-ES/" target="_blank" rel="noopener"): img(src="/mediolanum-logo.png", alt="Banco Mediolanum")
				//- Specific sponsors (copa)
				a.he-btm-patro__item(v-if="(match_info.id_competition == 2)" href="https://www.movistar.es/" target="_blank" rel="noopener"): img(src="/movistar-logo.png", alt="movistar")
				a.he-btm-patro__item(v-if="(match_info.id_competition == 2)" href="https://www.endesa.com/es.html" target="_blank" rel="noopener"): img(src="/endesa-logo-partner.png", alt="endesa")
				a.he-btm-patro__item(v-if="(match_info.id_competition == 2)" href="https://www.ionos.es/" target="_blank" rel="noopener"): img(src="/ionos-logo-partner.png", alt="ionos")
				a.he-btm-patro__item(v-if="(match_info.id_competition == 2)" href="https://www.toyota.es/" target="_blank" rel="noopener"): img(src="/toyota-logo-partner.png", alt="toyota")
				a.he-btm-patro__item(v-if="(match_info.id_competition == 2)" href="https://www.bancomediolanum.es/es-ES/" target="_blank" rel="noopener"): img(src="/mediolanum-logo.png", alt="Banco Mediolanum")

			img.he__bg(:src="match_info.arena_image", :alt="arenaName")
	transition(name="fade")
		SubNav(v-if="isHeadReady && $route.params.id_match")
	.he-scroll(v-if="isHeadReady" :isScrolled="isScrolled")
		.he(ref="hesc")
			NoSignal
			.he-top
				.he-top__round(
					@click="$store.state.general.navigation_prematch ? goPreviousMatch() : toggleNav()" 
					role="button")
					i: font-awesome-icon(icon="chevron-left")
					span(v-if="isCurrentMatchLoaded && !$store.state.general.navigation_prematch") {{ parsedRound }}
					span(v-if="isCurrentMatchLoaded && $store.state.general.navigation_prematch") {{ $t('Back') }}

			.ge-match.ge-match--head
				MatchInfo(:match_info="match_info")

			img.he__bg(:src="match_info.arena_image", :alt="arenaName")
		SubNav(v-if="$route.params.id_match")

</template>

<style lang="sass">

.he
	position: relative
	color: $white
	box-sizing: border-box
	padding: 1rem
		// top: 4rem
	display: flex
	flex-direction: column
	align-items: center
	+breakpoint(large)
		padding: 1rem 2rem	

	&-wrap
		position: relative
		z-index: 2
		&--upcoming
			height: 100%

			&.he-wrap--app
				.ge-ti
					padding-top: 4rem


		&--app
			.he
				padding-top: 4.5rem
				&-scroll
					.he
						padding-top: 4.5rem

	&__bg
		position: absolute
		z-index: -1
		width: 100%
		height: 100%
		object-fit: cover
		top: 0
		left: 0
		filter: brightness(40%)
		background-color: $black


	&-top
		display: grid
		grid-template-columns: 1fr auto 1fr
		width: 100%
		grid-column-gap: 1rem
		// grid-row-gap: 1.8rem
		// grid-row-gap: 0.5rem
		grid-template-areas: "round logo comp"
		+breakpoint(medium)
			grid-template-areas: "round logo comp"
		+breakpoint(large)
			grid-template-areas: "round . ." "info logo patro"

		&-info
			display: none
			grid-auto-flow: row
			grid-area: info
			color: $white
			grid-gap: 0.5rem
			justify-items: center
			
			// +breakpoint(medium)
			// 	display: grid
			// 	justify-items: end
				
			+breakpoint(large)
				display: grid
				justify-content: start
				grid-auto-flow: column
				grid-gap: 1.5rem

			&-itm
				display: grid
				grid-auto-flow: column
				grid-gap: 0.5rem
				align-items: baseline
				line-height: 1.2em
				font-size: 0.9em
				& > i
					font-size: 1.2rem
				&__date
					display: flex
					line-height: 1.2em
					letter-spacing: 0.5px
					& > *
						&:first-child
							&::after
								content: "|"
								padding: 0 0.4rem

		&-patro
			display: none
			+breakpoint(large)
				display: grid
			grid-area: patro
			grid-auto-flow: column
			grid-gap: 1rem
			align-content: start
			justify-content: end
			&__item
				display: flex
				img
					max-height: 12px
					+breakpoint(medium)
						max-height: 15px
		&-logo
			grid-area: logo
			// display: contents
			display: flex
			align-items: flex-end
		
			img
				// align-self: end
				height: 100%
				max-height: 25px
				+breakpoint(medium)
					max-height: 30px
	

		&__comp
			max-height: 20px
			grid-area: comp
			align-self: end
			justify-self: end
			max-width: 100px
			+breakpoint(medium)
				max-height: 25px
				max-width: 140px
			+breakpoint(large)
				display: none

		&__round
			grid-area: round
			display: grid
			grid-auto-flow: column
			grid-gap: 0.5rem
			justify-content: start
			font-size: 1.1em
			font-weight: $bold
			cursor: pointer
			align-self: end
			padding-bottom: 0.1rem
			line-height: 1em
			// white-space: nowrap
			+breakpoint(medium)
				padding-bottom: 0
			+breakpoint(large)
				display: none
				&--back
					padding-bottom: 1rem
					display: grid


	&-btm-patro
		padding: 1rem 0
		display: grid
		grid-area: patro
		grid-auto-flow: column
		grid-gap: 1rem
		+breakpoint(large)
			display: none

		&__item
			display: flex
			img
				max-height: 12px
				+breakpoint(medium)
					max-height: 15px

	&__btn_tv
		+btn
		height: 2.4rem
		margin: 0
		background-color: rgba(#fff, 0.4)
		border: none
		color: $white
		font-weight: $bold
		// margin: 
		// 	top: 1.5rem
		// 	bottom: 0.5rem
		@media (hover: hover) and (pointer: fine)
			&:hover
				background-color: $primary-color
				border: none
				color: $white
			
		// +breakpoint(large)
		// 	margin: 1rem 0

	&-scroll
		position: fixed
		display: flex
		flex-direction: column
		top: 0
		z-index: 20
		width: 100%
		transform: translateY(-100%)
		opacity: 0
		transition: all 0.2s

		+breakpoint(large)
			max-width: calc(100% - 360px)

		&[isScrolled]
			opacity: 1
			transform: translateY(0)
			transition: transform 0.3s
			display: none
			@media (min-height: 600px)
				display: flex
				
		.he
			padding: 1rem
				// top: 0.5rem
			&-top
				grid-template-columns: 1fr
				grid-template-areas: "round comp"

				&__round
					display: grid
					+breakpoint(large)
						display: none
				&__comp
					display: none

		.ge-match
			&--head
				padding: 0

			&-info
				&__score
					font-size: 1.5rem
					max-width: 44px
					padding: 0 0.5rem
				&-shield
					flex-basis: 44px
					padding: 0
					min-height: 44px

			+breakpoint(medium)
				&-info
					&__score
						font-size: 2rem
						max-width: 56px
						padding: 0 0.5rem
					&-shield
						flex-basis: 56px
						padding: 0.5rem
						min-height: 56px

	




</style>

<script>
import api from "@/api/index";

import Upcoming from "@/components/subcomponents/head/Upcoming.vue";
import NoSignal from "@/components/subcomponents/head/NoSignal.vue";

import AnimatedValue from "@/components/subcomponents/general/AnimatedValue.vue";
import SubNav from "@/components/subcomponents/head/SubNav.vue"
import MatchInfo from "@/components/subcomponents/head/Match-info.vue"

import { parseStatus } from "@/utils/match.js";



export default {
	name: "Header",
	data() {
		return {
			loaded: false,
			match_info: "",
			overview: "",
			periods: "",
			localFouls: 0,
			visitorFouls: 0,
		};
	},
	computed: {

		parsedRound() {
			const descriptor = this.match_info.matchweek_descriptor
			const number = this.match_info.matchweek_number
			if (descriptor) {
				if (descriptor.includes('Jornada')) {
					return `${this.$i18n.t("Round")} ${number}`
				}
				if (this.$store.state.general.lang == 'en') {
					if (descriptor.includes('1/8 de final')) {
						return descriptor.replace('1/8 de final', 'Last 16')
					}
					if (descriptor.includes('1/4 de final')) {
						return descriptor.replace('1/4 de final', 'Quarterfinals')
					}
					if (descriptor.includes('Cuartos de final')) {
						return descriptor.replace('Cuartos de final', 'Quarterfinals')
					}
					if (descriptor.includes('Semifinales')) {
						return descriptor.replace('Semifinales', 'Semifinals')
					}
				}
			}
			return descriptor
		},


		showBroadcast() {
			if (this.$data.match_info) {
				if (this.match_info.id_competition != 10) {
					return this.$data.match_info.broadcast[0] && this.isCurrentMatchLoaded
				}
			}
			return false
		},
		isCurrentMatchLoaded() {
			return (this.$store.state.match.id == this.$route.params.id_match)
		},
		collapsedHeight() {
			return this.$store.state.general.collapsedHeight + 1
		},
		isMedium() {
			return this.$store.state.general.isMedium
		},
		isLarge() {
			return this.$store.state.general.isLarge
		},
		isScrolled() {
			if (this.$refs.he) {
				if (this.isSmall)
					return this.scrollTop > (this.$refs.he.clientHeight - this.collapsedHeight)
				if (this.isMedium)
					return this.scrollTop > (this.$refs.he.clientHeight - this.collapsedHeight)
				return this.scrollTop > (this.$refs.he.clientHeight - this.collapsedHeight)
			}
			return this.scrollTop > 120
		},
		isHeadReady() {
			return this.$store.state.general.isHeadReady;
		},
		actual() {
			return this.$store.state.general.actual;
		},
		isActual() {
			return this.$store.state.general.actual.competition;
		},
		refreshSignal() {
			return this.$store.state.general.refreshSignal;
		},
		matchStatus() {
			return this.$store.state.match.status;
		},
		isUpcoming() {
			return this.$store.state.match.status == "upcoming";
		},
		isPrematch() {
			return this.$route.name.split(".")[1] == "prematch";
		},
		isLocalBonus() {
			if (this.loaded)
				return this.localFouls > 4
			else
				return 0
		},
		isVisitorBonus() {
			return this.visitorFouls > 4;
		},
		isMatchSelected() {
			return !!this.$route.params.id_match;
		},
		isSmall() {
			return this.$store.state.general.isSmall;
		},

		parsedDate() {
			if (this.match_info.start_date) {
				let d = new Date(this.match_info.start_date * 1000);
				return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
			}
			if (this.$store.state.general.refreshing) {
				return ''
			}
			return this.$i18n.t('Date to be determined')
		},
		parsedTime() {


			if (this.match_info.time) {
				let d = new Date((this.match_info.start_date) * 1000);
				return d.toTimeString().substr(0, 5);
				// return d.toUTCString().slice(17,22);
			}
			return this.$i18n.t('TBD')
		},
		isTop() {
			return this.$store.state.general.isTop;
		},
		scrollTop() {
			return this.$store.state.general.scrollTop;
		},
		headHeight() {
			return { height: `${this.$store.state.general.headHeight}px` };
		},
		idMatch() {
			return this.$route.params.id_match;
		},
		baseHeadHeight() {
			return this.$store.state.general.baseHeadHeight;
		},
		quarterNum() {
			return this.$store.state.match.quarterNum;
		},
		arenaName() {
			return this.$store.state.match.arena;
		},
		getCompetitionLogo() {
			if (this.match_info.id_competition == 3) {
				return "/competicion/supercopa-logo.png"
			} else if (this.match_info.id_competition == 2) {
				return "/competicion/copa-del-rey-logo.png"
			} else if (this.match_info.id_competition == 10) {
				return "/competicion/minicopa-endesa-logo.png"
			} else {
				if (this.match_info)
					return this.match_info.competition.url_image_negative
				return ''
			}
		}
	},
	methods: {
		goPreviousMatch() {
			if (this.$store.state.general.navigation_prematch) {

				let routeData = '/' + this.$store.state.general.lang + '/' + this.$store.state.general.navigation_prematch + '?match=true'
				if (this.$store.state.general.isApp) {
					routeData += '&app=true'
				}
				window.location.href = routeData;
			}

		},

		reloadPage() {
			this.$store.commit('general/deactivateRefreshSignal')
			this.$store.commit('general/clearRefreshSignal')
			setTimeout(() => {
				this.$store.commit('general/activateRefreshSignal')
				this.$store.commit('general/setRefreshSignal')
			}, 5);
			// if (this.$store.state.general.refreshing){
			// 	window.location.reload();
			// }
		},
		updateMatchInfo() {
			if (this.idMatch) {
				api.match.getMatchInfo(this.idMatch).then(data => {
					if (data) {
						this.$data.match_info = data;
						this.setLastPeriodNum();
						this.loaded = true;
						this.$store.commit("general/setHeadReady", true);
						this.$store.commit("general/setRefreshing", false)
					} else {
						this.$store.commit("general/setRefreshing", true)
					}
					return data
				}).then((data) => {
					if (parseStatus(data.status) !== this.$store.state.match.status) {
						this.$store.dispatch("match/loadMatchData", this.$route.params.id_match);
					}

					if (this.isUpcoming && !this.isPrematch) {
						this.$router.push({
							name: (this.$data.match_info.live || this.$data.match_info.finalized || this.$data.match_info.selected_players) ? this.$store.state.general.lang + '.overview' : this.$store.state.general.lang + '.prematch',
							params: { id_match: this.$data.match_info.id, goTop: true }
						});
					}
					if (data) {
						if (this.$store.state.match.status == "playing" || this.$store.state.general.refreshing) {
							this.updateMatchStats();
						}
					}
				});

			}
		},
		async toggleNav() {
			await this.$store.commit("general/setNav", 1);
			this.scrollToActiveElement()
		},
		scrollToActiveElement() {
			const element = document.querySelector(".nav-top-sec-swipe-item--selected")
			const parent = document.querySelector(".nav-top-sec-swipe")
			var position = element.offsetLeft - (parent.getBoundingClientRect().width - element.getBoundingClientRect().width) / 2;
			parent.scrollTo({ top: 0, left: position, behavior: "auto" })
		},
		getPeriodStr(period) {
			if (period < 5) {
				return period + this.$i18n.t("Q");
			} else {
				return `${this.$i18n.t("OT")}${period - 4}`;
			}
		},
		getCronoStr(sec) {
			let crono = new Date(sec * 1000);
			return crono.toTimeString().substr(3, 6);
		},
		setLastPeriodNum() {
			if (this.$data.match_info.period_marker) {
				let periodNum = this.$data.match_info.period_marker.length;
				this.$store.commit("match/setQuarterNum", periodNum);
			}
		},
		updateMatchStats() {
			if (
				this.idMatch &&
				this.$store.state.match.idCompetition &&
				this.$data.match_info.period_marker
			) {
				let periodNum = this.$data.match_info.period_marker.length;
				api.match
					.getMatchStats(
						this.idMatch,
						periodNum
					)
					.then(data => {
						this.$data.periods = data;
						this.$data.localFouls = data.localFouls;
						this.$data.visitorFouls = data.visitorFouls;
					});
			}
		}
	},
	watch: {
		isLarge() {
			if (this.$refs.hesc) {
				this.$store.commit("general/setCollapsedHeight", this.$refs.hesc.clientHeight);
			}
		},
		isMedium() {
			if (this.$refs.hesc) {
				this.$store.commit("general/setCollapsedHeight", this.$refs.hesc.clientHeight);
			}
		},
		isSmall() {
			if (this.$refs.hesc) {
				this.$store.commit("general/setCollapsedHeight", this.$refs.hesc.clientHeight);
			}
		},
		scrollTop() {
			if (this.$refs.hesc) {
				this.$store.commit("general/setCollapsedHeight", this.$refs.hesc.clientHeight);
			}
			if (this.$refs.he) {
				this.$store.commit("general/setHeadHeight", this.$refs.he.clientHeight);
			}
		},
		idMatch() {
			this.updateMatchInfo();
		},
		quarterNum() {
			if (this.$refs.hesc) {
				this.$store.commit("general/setCollapsedHeight", this.$refs.hesc.clientHeight);
			}
		},
		refreshSignal(newValue) {
			if (newValue) {
				if (!this.isCurrentMatchLoaded)
					this.$store.dispatch('match/loadMatchData', this.$route.params.id_match)
				this.updateMatchInfo();
			}
		},
	},
	mounted() {
		if (this.idMatch) {
			this.updateMatchInfo();
		}
	},
	components: {
		Upcoming,
		AnimatedValue,
		SubNav,
		MatchInfo,
		NoSignal
	}
};
</script>
